const useManualEntriesStyles = () => {
    return {
        manualEntriesCardStyles: {
            display: 'flex',
            flexDirection: 'column',
            p: 1.5,
            gap: 1
        }
    };
};
export default useManualEntriesStyles;
